<template>
  <div class="wizard-body small-9 columns">
    <whatsapp-embedded-signup v-if="isEmbedded" />
    <cloud-whatsapp v-else-if="isManual" show-back />
  </div>
</template>

<script>
import CloudWhatsapp from './CloudWhatsapp';
import WhatsappEmbeddedSignup from './WhatsappEmbeddedSignup';
import { EMBEDDED_PATH, MANUAL_PATH } from '../helpers/whatsappConnectGuard';

// Paso 2 del alta de WhatsApp Cloud: muestra la conexión asistida o la manual según ?path=.
// La ruta garantiza (beforeEnter) que el camino venga, así que aquí no hay redirecciones.
export default {
  components: {
    CloudWhatsapp,
    WhatsappEmbeddedSignup,
  },
  computed: {
    // Camino elegido en el paso anterior.
    path() {
      return this.$route.query.path;
    },
    // Conexión asistida con el popup de Meta.
    isEmbedded() {
      return this.path === EMBEDDED_PATH;
    },
    // Configuración manual pegando credenciales.
    isManual() {
      return this.path === MANUAL_PATH;
    },
  },
};
</script>
